import React, { useEffect } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import actions from './actions'
import Eyecon from '../../../Form/Eyecon'
import FeatureListItem from '../../../FeatureListItem'
import styles from './CollectionDetailContent.module.scss'

export const CollectionDetailContent = (props) => {
	useEffect(() => {
		if (props.featureScrollPosition) {
			const currentElement = document.getElementById(props.featureScrollPosition)
			if (currentElement) {
				currentElement.scrollIntoView({ block: 'center', inline: 'nearest' })
			}
		}
	}, [props.selectedCollectionLoading])

	const toggleAllFeaturesVisibility = (visibility) => {
		if (props.collection.featureIds.length) {
			props.toggleAllFeaturesVisibility(props.collection, visibility)
		}
	}
	return (
		<div className={styles.contentContainer}>
			<div className={styles.listHeader}>
				<p className={styles.sectionTitle}>Content</p>
				{props.collectionFeatures.length ? <Eyecon isOn={props.anyFeaturesVisible} onChange={(visibility) => toggleAllFeaturesVisibility(visibility)} /> : null}
			</div>
			{props.collectionFeatures.length ? (
				<ul className={styles.contentList}>
					{props.collectionFeatures.map((cf, i) => {
						return <FeatureListItem feature={cf} isDisabled={props.isDisabled} isSelected={cf.isSelected} isVisible={cf.isVisible} key={i} onClick={() => props.featureClicked(cf)} />
					})}
				</ul>
			) : (
				<div className={styles.noContent}>
					<p>No features in this hunt.</p>
				</div>
			)}
		</div>
	)
}

CollectionDetailContent.propTypes = {
	collection: PropTypes.object,
	isDisabled: PropTypes.bool,
	collectionFeatures: PropTypes.array,
	featureScrollPosition: PropTypes.string,
	anyFeaturesVisible: PropTypes.bool,
	selectedCollectionLoading: PropTypes.bool,
	visibleFeatureIds: PropTypes.array,
	// actions
	featureClicked: PropTypes.func,
	toggleAllFeaturesVisibility: PropTypes.func,
	toggleFeatureVisibility: PropTypes.func,
}

export default connect((model) => {
	const { selectedCollectionLoading } = model.collections
	let props = { selectedCollectionLoading }
	if (!selectedCollectionLoading) {
		const { sideBarScrollPosition } = model.app
		const { selectedCollection: collection } = model.collections
		const { featuresList, preferences } = model.features
		const featureScrollPosition = sideBarScrollPosition.features
		const collectionFeatures = []
		let anyFeaturesVisible = false
		let isDisabled = false
		let loaderText = 'Loading Content...'

		if (collection.featureIds.length) {
			let feature = null
			// let featureIsVisible = false
			for (let fli = 0; fli < featuresList.length; fli++) {
				feature = featuresList[fli]
				if (collection.featureIds.includes(feature.uuid)) {
					if (!preferences.visible.features.length) {
						feature.isVisible = preferences.visible.all
					} else {
						feature.isVisible = preferences.visible.features.includes(feature.id)
					}
					// if (featureIsVisible) {
					// 	feature.isVisible = true
					// } else {
					// 	feature.isVisible = false
					// }
					collectionFeatures.push(feature)
				}
			}
			const featureIndex = collectionFeatures.findIndex(cf => cf.isVisible)
			if (featureIndex > -1) anyFeaturesVisible = true
		}
		props = {
			...props,
			anyFeaturesVisible,
			collection,
			collectionFeatures,
			featureScrollPosition,
			isDisabled,
			loaderText,
		}
	}
	return props
}, actions)(CollectionDetailContent)
